import { Box, Typography } from "@mui/material";
import { IAttendance_Row } from "../../services/attendance/attendance-service";
import { RUDTable } from "../Table/RUDTable";
import { dateFormatter } from "../constants";
import SingleAttendanceHistory from "./SingleAttendanceHistory";

type Props = {
    history: IAttendance_Row;
};

export default function User_Attendance_History({ history }: Props) {
    function calculateWorkingHours(checkIn?: string, checkOut?: string) {
        if (!checkIn || !checkOut) return "—";

        const start = new Date(checkIn).getTime();
        const end = new Date(checkOut).getTime();

        if (isNaN(start) || isNaN(end) || end <= start) return "—";

        const diffMs = end - start;

        const hours = Math.floor(diffMs / (1000 * 60 * 60));
        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

        return `${hours}h ${minutes}m`;
    }

    function getAttendanceIdsForDay(row: any) {
        return row.ids ?? [];
    }
    // async function get_rows() {
    //     return Promise.resolve([
    //         {
    //             success: true,
    //             message: "",
    //             count: Object.entries(history.checkInOutByDay).length,
    //             rows: Object.entries(history.checkInOutByDay).map(
    //                 ([date, { CheckIn, CheckOut }]) => ({
    //                     date,
    //                     CheckIn: CheckIn
    //                         ? dateFormatter.format(new Date(CheckIn))
    //                         : "N / A",
    //                     CheckOut: CheckOut
    //                         ? dateFormatter.format(new Date(CheckOut))
    //                         : "N / A",
    //                     user_pin: history.user.pin,
    //                     total_hours: calculateWorkingHours(
    //                         CheckIn as any,
    //                         CheckOut as any
    //                     ),

    //                 })
    //             ),
    //         },
    //         null,
    //     ]);
    // }

    async function get_rows() {
        return Promise.resolve([
            {
                success: true,
                message: "",
                count: Object.entries(history.checkInOutByDay).length,
                rows: Object.entries(history.checkInOutByDay).map(
                    ([date, { CheckIn, CheckOut, ids }]) => ({
                        date,
                        CheckIn: CheckIn
                            ? dateFormatter.format(new Date(CheckIn))
                            : "N / A",
                        CheckOut: CheckOut
                            ? dateFormatter.format(new Date(CheckOut))
                            : "N / A",
                        user_pin: history.user.pin,
                        total_hours: calculateWorkingHours(
                            CheckIn as any,
                            CheckOut as any
                        ),
                        ids, // include ids in the row
                    })
                ),
            },
            null,
        ]);
    }

    return (
        <Box>
            <RUDTable
                readables={{
                    "Attendance IDs": "Attendance IDs",
                    date: "Date",
                    CheckIn: "Check In",
                    CheckOut: "Check Out",
                    total_hours: "Total Hours",
                    "Attendance History Day Wise":
                        "Attendance History Day Wise",
                }}
                getter={get_rows}
                customCols={[
                    {
                        header: "Attendance History Day Wise",
                        content: (row) => {
                            return (
                                <SingleAttendanceHistory
                                    row={row}
                                    type="singleUserAttendance"
                                />
                            );
                        },
                    },

                    {
                        header: "Attendance IDs",
                        content: (row) => {
                            const ids = getAttendanceIdsForDay(row);
                            return (
                                <Typography variant="body2">
                                    {ids?.length ? ids.join(", ") : "—"}
                                </Typography>
                            );
                        },
                    },
                ]}
                ops={{ read: "" }}
            />
        </Box>
    );
}
